/** The API writes that are in flight; a forced reload waits for them. */
let inFlight = 0;
const waiters = new Set<() => void>();

export function writesInFlight(): number {
  return inFlight;
}

const saved = new Set<() => void>();

/** Call `listener` after each write that ends with no error; it returns the stop function. */
export function onWriteSaved(listener: () => void): () => void {
  saved.add(listener);
  return () => saved.delete(listener);
}

/** Count the write while it runs; `changes` false: a POST that only reads. */
export function trackWrite<T>(work: Promise<T>, changes = true): Promise<T> {
  inFlight += 1;
  const done = () => {
    inFlight -= 1;
    if (inFlight === 0) waiters.forEach((wake) => wake());
  };
  work.then(() => {
    done();
    if (changes) saved.forEach((listener) => listener());
  }, done);
  return work;
}

/** Resolve when no write is in flight, or after `maxMs`; true when all writes ended. */
export function whenWritesDone(maxMs: number): Promise<boolean> {
  if (inFlight === 0) return Promise.resolve(true);
  return new Promise((resolve) => {
    const wake = () => {
      clearTimeout(timer);
      waiters.delete(wake);
      resolve(inFlight === 0);
    };
    const timer = setTimeout(wake, maxMs);
    waiters.add(wake);
  });
}

/** For tests. */
export function resetWrites(): void {
  inFlight = 0;
  waiters.clear();
}
